import gsap from "gsap";

export function runLoader() {
    const loader = document.querySelector(".loader");
    if (!loader) return Promise.resolve();

    if (!document.documentElement.classList.contains("show-loader")) {
        loader.remove();
        return Promise.resolve();
    }

    return new Promise<void>(resolve => {
        const tl = gsap.timeline({
            defaults: { duration: 0.7, delay: 2, ease: "power2.out" },
        });

        tl.fromTo(
            loader,
            { autoAlpha: 1 },
            {
                autoAlpha: 0,
                onStart: () => {
                    resolve();
                },
                onComplete: () => {
                    sessionStorage.setItem("hasSeenLoader", "true");
                    document.documentElement.classList.remove("show-loader");
                    loader.remove();
                },
            }
        );
    });
}
